import type { IUser } from "../../../../types/models/user.models.types";
import { useGetHttp } from "../../http.hook";

export interface IComment {
  id: string;
  message: string;
  createdAt: Date;
  updatedAt: Date;
  addedByUser: IUser;
}

interface IResponse {
  comments: Array<IComment>;
}


export function useGetProposalSocialCommentsAdminHttp() {
  return useGetHttp<IResponse>({
    path: "/admin/campaigns/proposals/:proposalId/socials/:proposalSocialId/comments",
  });
}
